import { Box } from '@mui/material';
import SimContainer from 'components/SimContainer';

const SimSliderItem = ({ children, sx }) => (
	<Box
		margin={0}
		className={'jarallax'}
		data-jarallax
		data-speed='0.2'
		position={'relative'}
		height={{ xs: '100vh', sm: '90vh', md: '90vh', lg: '90vh' }}
		display={'flex'}
		alignItems={'center'}>
		<Box className={'jarallax-img'} sx={sx} />
		<SimContainer>{children}</SimContainer>
	</Box>
);

export { SimSliderItem };
